import { useState } from 'react';
import { programs } from '../data/programs';
import ProgramAccordion from './ProgramAccordion';
import EsyohWidget887581 from './EsyohWidget887581';
import EsyohWidget887582 from './EsyohWidget887582';

function Directory() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="directory section" id="programs">
      <EsyohWidget887581 />
      <EsyohWidget887582 />

      <div className="section-heading align-left">
        <p className="eyebrow">Compare your options</p>
        <h2>Best PTA Programs in Los Angeles</h2>
        <p>
          PTA programs can differ significantly in prerequisites, clinical
          hours, schedule, tuition, location, credential, and admission process.
          Use these profiles to narrow your search, then contact each institution
          to verify current program details.
        </p>
        <p>
          <strong>
            Click the green request info button to request additional information
            from each school.
          </strong>
        </p>
      </div>

      <div className="accordion-stack">
        {programs.map((program, index) => (
          <ProgramAccordion
            key={program.name}
            program={program}
            isOpen={openIndex === index}
            onToggle={() =>
              setOpenIndex(openIndex === index ? -1 : index)
            }
          />
        ))}
        <p>
          Strong PTA programs combine classroom instruction, movement and
          health science, hands-on laboratory practice, and supervised clinical
          education. Students should also ask about accreditation, licensure exam
          preparation, patient-care simulations, clinical partners, and support
          after graduation.
        </p>
        <EsyohWidget887581 />
        <EsyohWidget887582 />
      </div>
    </section>
  );
}

export default Directory;